export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" d="m11.22 14.733-2.938-2.938a.75.75 0 0 0-1.06 1.06l4.22 4.221a.75.75 0 0 0 1.06 0l4.255-4.254a.75.75 0 0 0-1.06-1.06l-2.977 2.977.057-12.707C17.937 2.43 22 6.74 22 12c0 5.523-4.477 10-10 10S2 17.523 2 12c0-5.28 4.091-9.6 9.276-9.971l-.056 12.704Z"/>
</svg>
`;
